import React, { useState, useEffect } from 'react';

export function OTPCountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(120);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(interval); // cleanup
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${mins}:${secs}`;
  };

  return (
    <div>
      <h2>{formatTime(timeLeft)}</h2>
    </div>
  );
}
